import { ColumnDef } from "@tanstack/table-core/build/lib/types";
import type { Exception } from "../../shared/Types";
import {mapPriorityToStatus } from "../../shared/Utils";
import { StatusIndicator, Text } from "@nike/eds";

export type TableColumn<T> = ColumnDef<T, any> & {
  header: string | React.ReactNode | (() => React.ReactNode);
  accessorKey: keyof T | string;
  filterType?: "select" | "text";
};

export function formatExceptionDate(dateString: string) {
  return new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export const getTableColumns = (): TableColumn<Exception>[] => [
  { 
    header: "Priority",
     accessorKey: "priority",
     size: 100,
     enableHiding: false,
     enableSorting: false,
     cell: ({ row }) => {
      return <StatusIndicator label={row.original.priority} size="x-large" status={mapPriorityToStatus(row.original.priority)} />;
    },
  },
  {
    header: "Mode of Transport",
    accessorKey: "consignment_modeOfTransport",
    accessorFn: (row) => row.consignment.modeOfTransport,
    size: 200,
    enableHiding: false,
    enableSorting: false,
  },
  { 
    header: "Status", 
    accessorKey: "status", 
    size: 100, 
    enableHiding: false,
    enableSorting: false 
  },
  {
    header: "Type",
    accessorKey: "description",
    size: 200,
    filterType: "text",
    enableSorting: false,
  },
  {
    header: "Creation Date",
    accessorKey: "creationDate",
    size: 200,
    enableSorting: false,
    cell: ({ row }) => formatExceptionDate(row.original.creationDate),
  },
  {
    header: "Product Division",
    accessorKey: "consignment_productDivision",
    accessorFn: (row) => row.consignment.productDivision,
    size: 180,
    enableSorting: false,
  },
  { 
    header: "Consignment / BOL", 
    accessorKey: "consignment_id",
    accessorFn: (row) => `${row.consignment.id} / ${row.consignment.billOfLadingNbr}`, 
    size: 150, 
    enableSorting: false,
    cell: ({ row }) => (
      <>
        {row.original.consignment.id}<br/>
        {row.original.consignment.billOfLadingNbr}

      </>
    ),
  },
  {
    header: "Country of Import",
    accessorKey: "consignment_dischargeCountry",
    accessorFn: (row) => row.consignment.dischargeCountry,
    size: 180,
    enableSorting: false,
  },
  {
    header: "Assigned User",
    accessorKey: "assignee_name",
    accessorFn: (row) => row.assignee?.name || "Unassigned",
    size: 150,
    enableSorting: false,
  },
    {
    header: "Container ID",
    accessorKey: "container_id",
    size: 150,
    enableSorting: false,
    cell: ({ row }) => {
      return 'TBD';
    },
  },
  // {header: 'Assignee', accessorKey: 'assignee.name', size: 150, cell: ({row}) => (
  //     // if not assigned show a button with Assign to Me
  //     row.original.assignee.id ? (
  //         <span>{row.original.assignee.name}</span>
  //     ) : (
  //         <>
  //         <Button size='small' onClick={() => handleAssignToMe(row.original)}>Assign to Me</Button>
  //         <Button size='small' onClick={() => handleAssignToMe(row.original)}>Reassign</Button>
  //         </>
  //     )
  // )},
// switched to clicking on the row to open details
  // {
  //   header: "Actions",
  //   accessorKey: "actions",
  //   size: 100,
  //   enableSorting: false,
  //   enableColumnFilter: false,
  //   enableGlobalFilter: false,
  //   cell: ({ row }) => (
  //     <Button size="small" onClick={() => handleDetailsClick(row.original)}>
  //       Details
  //     </Button>
  //   ),
  // },
];